import React, { memo, useMemo } from 'react'
import styled from 'styled-components'
import { Box, getPaletteColor } from 'pcln-design-system'
import monthNameBuilder from '../utils/monthNameBuilder/monthNameBuilder'

const MonthNameBox = styled(Box)`
  font-size: ${(props) => props.theme.fontSizes[2]}px;
  font-weight: ${(props) => props.theme.bold};
  color: ${getPaletteColor('text.light')};
  background: ${getPaletteColor('background.light')};
  text-align: center;
  text-transform: capitalize;

  ${(props) => props.theme.mediaQueries.md} {
    color: ${getPaletteColor('text.dark')};
    background: ${getPaletteColor('background.lightest')};
  }
`

export interface IMonthNameProps {
  displayYear?: boolean
  locale?: string
  monthIndex: string | number
  year?: string | number
}

function MonthName({ displayYear, locale, monthIndex, year, ...props }: IMonthNameProps) {
  const memoizedMonthNames = useMemo(() => monthNameBuilder({ format: 'wide', locale })[monthIndex], [locale])

  return (
    <MonthNameBox {...props} borderRadius='lg' mx={[1, 2]} pb={[2, null, null, 0]} pt={2}>
      {memoizedMonthNames}
      {displayYear && ` ${year}`}
    </MonthNameBox>
  )
}

export default memo(MonthName)
